export default __webpack_public_path__ + "./fonts/download-svgrepo-com.46df6723.svg";